import React, { useContext, useEffect, useState } from 'react'
import UserReview from './UserReview'
import QuickBuyContext from '@context/QuickBuyContext'

const Reviews = ({
  data,
  sortPosition = "right",
  hideSeeAllButton = false,
  stickySortPosition = false,
}) => {
  const { setShowReviews } = useContext(QuickBuyContext)
  const [reviews, setReviews] = useState([])

    //console.log(data)

    useEffect(() => {
        setReviews(data)
    }, [data]);

  return (
    <React.Fragment>
      <section className="w-full">
        
        <div className="w-full">
          {
            
            reviews && reviews?.length > 0 ? reviews?.slice(0, 5)?.map((item, index) => {
                return <UserReview key={`$user-review-${index}`} reviews={item} />;
            }) : <></>
            
          }
        </div>

        {reviews?.length > 5 && (
          <div className="">
            <button
              className="btn-outline !px-6"
              onClick={() => setShowReviews(true)}
              aria-label="SELL ALL REVIEWS"
            >
              SEE ALL REVIEWS
            </button>
          </div>
        )}
      </section>
    </React.Fragment>
  );
};

export default Reviews